import { useState as a, useEffect as l } from "react";
import { focusVisibleManager as b } from "@storefront-ui/shared";
const s = b(), f = (t = {}) => {
  s.setupGlobalFocusEvents();
  const { isTextInput: e, autoFocus: i } = t, [n, u] = a(i || s.isFocusVisible());
  return l(() => {
    const o = (c, r) => {
      s.isKeyboardFocusEvent(e, c, r) && u(s.isFocusVisible());
    };
    return s.changeHandlers.add(o), () => {
      s.changeHandlers.delete(o);
    };
  }, [e]), { isFocusVisible: n };
};
export {
  f as useFocusVisible
};
